<template>
	<Popup
		v-model="selfDisplay"
		title="修改"
		confirmBtnText="修改"
		@confirmClick="handleUpdateClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>热门搜索</span>
				<el-input v-model="name" placeholder="热门搜索"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="nameTip"><i class="b_icon"></i>请输入热门搜索</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>序号</span>
				<el-input v-model="order" placeholder="序号"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="orderTip"><i class="b_icon"></i>请输入整数数字</template></div>
		</div>
	</Popup>
</template>

<script>
	import Api from '../../../../../../../api/index.js';

	export default{
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			obj: {
				type: Object,
				default() { return {}; }
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data() {
			return{
				loading: false,
				selfDisplay: false,
				
				name: '',
				order: '',
				nameTip: false,
				orderTip: false
			}
		},
		methods: {
			// 点击修改
			handleUpdateClick() {
				if (!this.name.trim()) {
					this.nameTip = true;
					return false;
				} else {
					this.nameTip = false;
				}
				if (!this.positiveReg.test(this.order)) {
					this.orderTip = true;
					return false;
				} else {
					this.orderTip = false;
				}
				this.update();
			},
			// 修改
			update() {
				const that = this;
				that.loading = true;
				let requestData = {
					hotId: that.obj.id,
					hotSearch: that.name,
					hotOrder: that.order
				};
				Api.updateAppHotSearch(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.loading = false;
					this.name = this.obj.name;
					this.order = this.obj.order;
					this.nameTip = false;
					this.orderTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
